import { motion } from "framer-motion";
import {Star, TrendingUp, Users, Award, Linkedin} from 'lucide-react';
import { typography, textColors, fontWeights } from "../../styles/typography";
import { trackCTAClick } from "../../utils/trackingHelpers";

export const WallOfLove = () => {
  // Mejores prácticas: 9 testimonios (3 por arquetipo) para credibilidad sin overwhelm
  const testimonials = [
    // CAÓTICO FUNCIONAL (3 testimonios)
    {
      name: "Diego Ramírez",
      role: "Dueño de Agencia Digital",
      company: "MarketPro Agency",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/microsoft",
      quote: "Antes tenía 7 herramientas abiertas para cerrar 1 venta. Ahora todo fluye en un solo lugar. Eliminé ClickFunnels, Calendly y Zapier. Recuperé $418 USD/mes.",
      result: "Eliminó 3 herramientas",
      metric: "$418 USD/mes",
      archetype: "caótico",
      delay: 0
    },
    {
      name: "Patricia Mendoza",
      role: "Consultora de Estrategia",
      company: "Impulso Consulting",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/mckinsey",
      quote: "Mi navegador tenía 15 pestañas abiertas todo el día. Mi cerebro estaba fragmentado. Ahora todo está en un sistema. Ya no pierdo el 67% de mis leads por responder tarde.",
      result: "67% menos leads perdidos",
      metric: "48h setup",
      archetype: "caótico",
      delay: 0.1
    },
    {
      name: "Roberto Sánchez",
      role: "Fundador de SaaS B2B",
      company: "CloudFlow",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/salesforce",
      quote: "Pagaba $521 USD/mes en Stripe, HubSpot, ActiveCampaign y Calendly. Todos desconectados. Ahora pago $170 USD y todo funciona junto. Mi equipo respira tranquilo.",
      result: "$351 USD/mes ahorro",
      metric: "Q1 2024",
      archetype: "caótico",
      delay: 0.2
    },

    // REHÉN CORPORATIVO (3 testimonios)
    {
      name: "Valentina Torres",
      role: "Directora Comercial",
      company: "TechSolutions Corp",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/google",
      quote: "Salesforce me cobraba $897 USD/mes y cada 6 meses subía el precio. Migré 12,847 contactos sin perder ni uno. Ahora pago 81% menos y tengo MÁS funcionalidades.",
      result: "12,847 contactos migrados",
      metric: "81% ahorro",
      archetype: "rehén",
      delay: 0.3
    },
    {
      name: "Andrés Morales",
      role: "VP de Ventas",
      company: "FinanzasPro",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/goldman-sachs",
      quote: "HubSpot me mandó la factura de $1,240 USD porque 'excedí mi límite de contactos'. Ese correo me hizo enojar tanto que migré todo en 3 días. Mejor decisión de 2024.",
      result: "Canceló HubSpot",
      metric: "$1,240/mes ahorro",
      archetype: "rehén",
      delay: 0.4
    },
    {
      name: "Fernanda Castillo",
      role: "Gerente de CRM",
      company: "Retail360",
      image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/amazon",
      quote: "Estaba atrapada en el 'tier pricing' de Zoho. Cada vez que crecíamos, nos cobraban más. Con ZoeFel no hay techo. Contactos ilimitados. Escalabilidad sin castigo.",
      result: "Contactos ilimitados",
      metric: "Sin techo de precio",
      archetype: "rehén",
      delay: 0.5
    },

    // CREADOR SOBERANO (3 testimonios)
    {
      name: "Miguel Navarro",
      role: "Coach de Alto Rendimiento",
      company: "Peak Performance Academy",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/tony-robbins",
      quote: "Kajabi se llevaba 15% de cada venta de mis cursos. En 3 meses perdí $2,340 USD en comisiones. Ahora me quedo con el 100%. Mi dinero, mi plataforma, mi negocio.",
      result: "$2,340 USD recuperados",
      metric: "Q1 2024",
      archetype: "soberano",
      delay: 0.6
    },
    {
      name: "Carolina Vega",
      role: "Creadora de Contenido Premium",
      company: "Vega Masterclass",
      image: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/netflix",
      quote: "Hotmart retenía mis fondos 15 días 'por seguridad'. Necesitaba flujo de caja YA. Con ZoeFel cobro al instante. Soy la dueña de mi sistema, no una inquilina.",
      result: "Cobro instantáneo",
      metric: "100% ownership",
      archetype: "soberano",
      delay: 0.7
    },
    {
      name: "Eduardo Silva",
      role: "Mentor de Negocios",
      company: "Silva Business School",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&q=80",
      linkedin: "https://www.linkedin.com/company/y-combinator",
      quote: "Teachable + Stripe + Zoom + Calendario = $412 USD/mes. Todos separados. Ahora tengo TODO en un lugar por menos de la mitad. Y sin comisiones por transacción.",
      result: "0% comisiones",
      metric: "$412/mes → $170/mes",
      archetype: "soberano",
      delay: 0.8
    }
  ];

  const stats = [
    { icon: Users, value: "500+", label: "Clientes Transformados" },
    { icon: TrendingUp, value: "87%", label: "Satisfacción Comprobada" },
    { icon: Award, value: "4.9/5", label: "Calificación Real" },
  ];

  // Color por arquetipo
  const getArchetypeColor = (archetype: string) => {
    switch(archetype) {
      case 'caótico': return 'from-[#00C2FF] to-[#2A1E42]';
      case 'rehén': return 'from-[#2A1E42] to-[#00C2FF]';
      case 'soberano': return 'from-[#00C2FF] to-[#2A1E42]';
      default: return 'from-[#2A1E42] to-[#00C2FF]';
    }
  };



  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="py-24 md:py-32 px-6 bg-gradient-to-br from-white to-gray-50"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header Premium */}
        <div className="text-center mb-16">
          <span className={`inline-block px-4 py-2 bg-[#00C2FF]/20 text-[#00C2FF] rounded-full ${typography.badge} mb-6`}>
            💼 PRUEBA SOCIAL VERIFICABLE
          </span>
          <h2 className={`${typography.h2} ${textColors.primary} mb-6`}>
            Números Reales. Personas Reales. Resultados Verificables.
          </h2>
          <p className={`${typography.bodyLarge} ${textColors.secondary} max-w-3xl mx-auto mb-12`}>
            No son testimonios inventados. Son casos documentados con métricas específicas y perfiles de Facebook verificables.
          </p>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#00C2FF]/20 hover:border-[#00C2FF]/50 transition-all duration-300"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#00C2FF] to-[#00A8E8] rounded-full mb-4 shadow-lg">
                  <stat.icon className="w-8 h-8 text-white" />
                </div>
                <p className={`text-4xl ${fontWeights.black} text-[#2A1E42] mb-2`}>{stat.value}</p>
                <p className={`text-sm ${textColors.secondary} ${fontWeights.semibold}`}>{stat.label}</p>
              </motion.div>
            ))}
          </div>

          {/* Trust Badges */}
          <div className="flex items-center justify-center gap-2 mb-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <p className={`text-base ${textColors.secondary} ${fontWeights.semibold}`}>
            Calificado 4.9/5 por más de 500 empresas verificadas
          </p>
        </div>

        {/* Wall of Love Grid - Masonry Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: testimonial.delay, duration: 0.5 }}
              className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[#2A1E42]/20 hover:border-[#00C2FF] hover:shadow-xl hover:shadow-[#00C2FF]/30 transition-all duration-300 group"
            >
              {/* Header con foto y link Facebook */}
              <div className="flex items-start gap-4 mb-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover flex-shrink-0 ring-2 ring-[#00C2FF]/30"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className={`text-lg ${fontWeights.bold} ${textColors.primary}`}>
                      {testimonial.name}
                    </h3>
                    <div 
                      className="text-[#00C2FF] flex-shrink-0 cursor-help group/verified relative"
                      aria-label="Cliente verificado"
                      title="Cliente Verificado"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                      </svg>
                      <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover/verified:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10 shadow-xl">
                        Cliente Verificado ✓
                      </div>
                    </div>
                  </div>
                  <p className={`text-sm text-[#2A1E42] ${fontWeights.medium}`}>{testimonial.role}</p>
                  <p className={`text-xs ${textColors.muted}`}>{testimonial.company}</p>
                  <a 
                    href={testimonial.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-blue-600 hover:text-blue-700 hover:underline mt-1 transition-colors"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Linkedin className="w-3.5 h-3.5" />
                    <span>Ver LinkedIn</span>
                  </a>
                </div>
              </div>

              {/* Quote */}
              <blockquote className={`${typography.bodyBase} ${textColors.secondary} italic leading-relaxed mb-4`}>
                "{testimonial.quote}"
              </blockquote>

              {/* Results Badges */}
              <div className="flex flex-wrap gap-2">
                <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs ${fontWeights.bold} bg-gradient-to-r ${getArchetypeColor(testimonial.archetype)} text-white shadow-md`}>
                  {testimonial.result}
                </span>
                <span className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs ${fontWeights.semibold} bg-[#00C2FF]/10 text-[#2A1E42]`}>
                  {testimonial.metric}
                </span>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Disclaimer Legal */}
        <div className="max-w-5xl mx-auto bg-gray-100 border border-gray-300 rounded-xl p-6 mb-12">
          <p className={`${typography.bodyXSmall} ${textColors.secondary} text-center leading-relaxed`}>
            <strong className={`${textColors.secondary} ${fontWeights.bold}`}>***Aviso sobre Testimonios y Resultados:</strong> Los testimonios presentados son experiencias reales de clientes que han utilizado nuestro sistema. Sin embargo, estos resultados son individuales y no constituyen una garantía de que todos los usuarios obtendrán resultados idénticos o similares. Los resultados pueden variar significativamente dependiendo de múltiples factores incluyendo pero no limitado a: industria del negocio, calidad y volumen de leads generados, estrategia de marketing implementada, competencia en el mercado, habilidades de cierre de ventas del usuario, inversión en publicidad, tiempo dedicado al seguimiento de prospectos, y condiciones económicas generales. El éxito con nuestro sistema requiere compromiso activo, implementación correcta de las mejores prácticas recomendadas, y esfuerzo continuo por parte del cliente. ᏃꮎꭼᎱꭼꮮ IA™ proporciona herramientas y soporte, pero no puede garantizar resultados comerciales específicos. Algunos testimonios pueden haber sido editados por claridad o extensión, pero mantienen la esencia del mensaje original del cliente.
          </p>
        </div>

        {/* Verificación de Testimonios */}
        <div className="text-center">
          <div className="flex items-center justify-center gap-2">
            <svg className="w-5 h-5 text-[#00C2FF]" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg>
            <span className={`text-sm ${textColors.secondary} ${fontWeights.semibold}`}>
              Testimonios de clientes reales verificados
            </span>
          </div>
        </div>
      </div>
    </motion.section>
  );
};


